<template>
  <v-dialog v-model="isOpen" max-width="500px" persistent>
    <v-card>
      <v-card-title class="text-h5"> {{ title }} </v-card-title>

      <v-card-text>
        <ConfirmToDelete
          :description="description"
          :alert-text="alertText"
          :document-name="documentName"
          :confirm-button-text="confirmButtonText"
          @confirm="handleConfirm"
          @cancel="handleCancel"
        >
          <template #extra-alerts>
            <slot name="extra-alerts" />
          </template>
        </ConfirmToDelete>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import ConfirmToDelete from './ConfirmToDelete.vue'

export default defineComponent({
  name: 'DeleteModal',

  components: {
    ConfirmToDelete,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Eliminar',
    },
    description: {
      type: String,
      default: '¿Estás seguro? Esta acción no se puede deshacer',
    },
    alertText: {
      type: String,
      default: 'Se eliminará',
    },
    documentName: {
      type: String as PropType<string | null>,
      default: null,
    },
    confirmButtonText: {
      type: String,
      default: 'Eliminar',
    },
  },

  emits: ['update:show', 'confirm', 'cancel'],

  computed: {
    isOpen: {
      get() {
        return this.show
      },
      set(value: boolean) {
        this.$emit('update:show', value)
      },
    },
  },

  methods: {
    handleCancel() {
      this.$emit('cancel')
      this.isOpen = false
    },

    async handleConfirm() {
      this.$emit('confirm')
      this.isOpen = false
    },
  },
})
</script>

<style scoped></style>
